export enum UserTypesEnum {
  ADMIN = 'ADMIN',
  DEFAULT = 'DEFAULT',
  VIP = 'VIP',
}

export enum UserTypesEnumFormatted {
  ADMIN = 'Admin',
  DEFAULT = 'Padrão',
  VIP = 'VIP',
}

export const toUserTypesEnum = (value: string): UserTypesEnum => {
  const toCheck = value?.trim()?.toUpperCase() ?? '';
  switch (toCheck) {
    case 'ADMIN':
      return UserTypesEnum.ADMIN;
    case 'VIP':
      return UserTypesEnum.VIP;
    default:
      return UserTypesEnum.DEFAULT;
  }
};
